import { render, staticRenderFns } from "./PurchaseHeader.vue?vue&type=template&id=48c79e01&"
import script from "./PurchaseHeader.vue?vue&type=script&lang=ts&"
export * from "./PurchaseHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports